import { render, staticRenderFns } from "./PriceFilterMobile.vue?vue&type=template&id=c907e08e&scoped=true&"
import script from "./PriceFilterMobile.vue?vue&type=script&lang=js&"
export * from "./PriceFilterMobile.vue?vue&type=script&lang=js&"
import style0 from "./PriceFilterMobile.vue?vue&type=style&index=0&id=c907e08e&lang=scss&scoped=true&"
import style1 from "./PriceFilterMobile.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c907e08e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c907e08e')) {
      api.createRecord('c907e08e', component.options)
    } else {
      api.reload('c907e08e', component.options)
    }
    module.hot.accept("./PriceFilterMobile.vue?vue&type=template&id=c907e08e&scoped=true&", function () {
      api.rerender('c907e08e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/MobileFilters/PriceFilterMobile.vue"
export default component.exports